// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3inxu","container":"styles_container__3wDEn","title":"styles_title___5_45","wrapper":"styles_wrapper__3lrpS","answer":"styles_answer__NiNZw"};